import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE, PHONE_HREF, scrollToIntake } from "../../lib/erg";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const intake = document.getElementById("intake");
      const past = window.scrollY > window.innerHeight * 0.6;
      const inForm = intake ? intake.getBoundingClientRect().top < window.innerHeight * 0.75 : false;
      setShow(past && !inForm);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      className={`sm:hidden fixed bottom-0 left-0 right-0 z-50 px-4 pt-3 bg-gradient-to-t from-erg-deep via-erg-deep/95 to-transparent transition-[opacity,transform] duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-2.5">
        <button
          data-testid="sticky-intake-cta"
          onClick={scrollToIntake}
          className="flex-1 rounded-full bg-erg-ember py-3.5 font-display font-semibold uppercase tracking-wide text-erg-ink text-[15px] active:scale-[0.98] transition-transform ember-pulse"
        >
          Start your intake
        </button>
        <a
          data-testid="sticky-phone-link"
          href={PHONE_HREF}
          className="grid place-items-center h-[52px] w-[52px] shrink-0 rounded-full border border-erg-aqua/50 bg-white/10 text-erg-aqua active:scale-95 transition-transform"
          aria-label={`Call or text ${PHONE}`}
        >
          <Phone className="h-5 w-5" />
        </a>
      </div>
      <a
        href={PHONE_HREF}
        className="mt-1.5 block text-center font-mono text-[11px] tracking-wide text-erg-dry/55"
      >
        or call / text {PHONE}
      </a>
    </div>
  );
};
